import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CHATHISTORY } from 'src/app/core/constants/feature-key.constants';
import { FeatureGuard } from 'src/app/core/guards/feature.guard';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { ContractGuard } from '../../../core/guards/contract.guard';

@Component({
  selector: 'app-tech-support-history',
  templateUrl: './tech-support-history.component.html',
  styleUrls: ['./tech-support-history.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class TechSupportHistoryComponent implements OnInit, OnDestroy {

  backBtnUrl: string;
  backBtnText: string;
  isLoaded: boolean = false;
  isActive: boolean = false;
  private destroy$ = new Subject<boolean>();

  constructor(private featureGuard: FeatureGuard, private loggedInUserSettings: LoggedInUserSettings, private contractGuard: ContractGuard) { }

  ngOnInit(): void {

    const joined$ = combineLatest(
      [
        this.loggedInUserSettings.$selectedContract,
      ]
    ).pipe(
      filter(([a]) => a !== null),
      takeUntil(this.destroy$)
    );

    joined$.subscribe(([selectedContract]: [ISelectedContract]) => {
      const isEnabled = this.featureGuard.canActivate(selectedContract.dealerId, CHATHISTORY);
      if (isEnabled) {
        this.isLoaded = true;
      }
      this.isActive = this.contractGuard.activateGuard(selectedContract);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
}
